import { datadogLogs } from '@datadog/browser-logs';

export function initDatadogLogs(config: {
  clientToken: string;
  site: string;
  service: string;
  env: string;
}) {
  datadogLogs.init({
    ...config,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}
